module.exports = __webpack_public_path__ + "img/V69.c6557420.jpg";